module.exports = __webpack_public_path__ + "media/images/v2/hassel_free_event-707b07c242b2bd85bf20499f81926046.png";